import axios from 'axios'
import { message } from 'ant-design-vue'
import router from '@/router'
const service = axios.create({
  //baseURL: 'http://1.15.94.52:9827',
  // baseURL: 'https://mobile.qdpi.net.cn/com.qgkj.ls',
  // baseURL: 'http://10.205.81.1:31834',
  baseURL: 'http://1.15.94.52:9833/com.qgkj.ls',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000
})

service.interceptors.request.use(
  config => {
    config.data.token = localStorage.token
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.status == 200) {
      if (response.data.code == 0) {
        return response.data.data
      } else if (response.data.code == -1) {
        // message.error('登录已过期，请重新登录')
        router.push('/')
      } else {
        let msg = response.data.content || response.data.message
        if (msg == '用户名或密码错误') {
          message.error(msg)
        }
        return Promise.reject(msg)
      }

    } else {
      return Promise.reject('网络错误')
    }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service
